<!-- <span class="fa-stack"
    placement="top"
    ngbTooltip="{{textTooltip}}"
    container="body">
    <i class="fas fa-circle fa-stack-2x" [ngClass]="itemColor"></i>
    <i class="fas fa-wifi fa-stack-1x fa-inverse"></i>
    <span class="fa fa-stack-1x" [ngClass]="itemColor">
        <span style="font-size:10px; margin-top:-18px; display:block;">
            {{rssi}}
        </span>
    </span>
</span> -->
<span class="badge badge-pill"
    [ngClass]="itemColor"
    placement="top"
    ngbTooltip="{{textTooltip}}"
    container="body">
    <i class="fas fa-wifi"></i>
    <span class="ml-1">{{dtgRssi | number:'3.0'}}</span>
</span>